"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const contractorProducts = [{
  title: "Phenolic legend plates",
  description: "22mm, 30mm, rectangular, and E-stop legend plates for control panels.",
  link: "/products/phenolic-legend-plates/",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/phenolic_legend_plates.png"
}, {
  title: "Panel nameplates",
  description: "Equipment ID nameplates for electrical panels.",
  link: "/products/engraved-nameplates/panel-nameplates/",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/panel_nameplates.png"
}, {
  title: "Electrical panel schedules",
  description: "Engraved breaker directory and schedule plates.",
  link: "/products/electrical-panel-schedules/",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/electrical_panel_schedules.png"
}, {
  title: "Pushbutton legend plates",
  description: "Operator-interface plates in standard control sizes.",
  link: "/products/pushbutton-legend-plates/",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/pushbutton_legend_plates.png"
}, {
  title: "Arc flash labels",
  description: "Produced from your study data, in durable engraved or printed construction.",
  link: "/products/arc-flash-labels/",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/arc_flash_labels.png"
}, {
  title: "Cable & wire ID tags",
  description: "Permanent circuit and conductor identification.",
  link: "/products/cable-wire-id-tags/",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/cable_wire_id_tags.png"
}];
const wp_query_params = {
  per_page: 3,
  order: "desc",
  orderby: "date"
};
const wp_query = new WP_Query(wp_query_params);
function DynamicProducts() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading || error || !products?.length) return null;
  return <div className="mt-20 pt-12 border-t border-border">
      <div className="max-w-3xl mb-8">
        <h3 className="text-2xl font-bold text-white mb-2 font-default">Ready-to-Ship Contractor Supplies</h3>
        <p className="text-card-foreground">Standard items available for immediate order.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.slice(0, 3).map((product, i) => <Card key={product.id} data-index={i} className="bg-card border-border overflow-hidden flex flex-col">
            {product.featured_image_url && <AspectRatio ratio={16 / 9}>
                <img src={product.featured_image_url} alt={product.title} className="object-cover w-full h-full" loading="lazy" />
              </AspectRatio>}
            <CardHeader className="p-5 pb-3">
              <CardTitle className="text-lg text-white font-default line-clamp-1">{product.title}</CardTitle>
              {product.price !== undefined && <div className="text-primary font-semibold mt-1">${product.price.toFixed(2)}</div>}
            </CardHeader>
            <CardContent className="p-5 pt-0 flex-grow">
              {product.short_description && <div className="text-sm text-card-foreground line-clamp-2 [&_p]:mb-0" dangerouslySetInnerHTML={{
            __html: product.short_description
          }} />}
            </CardContent>
            <CardFooter className="p-5 pt-0 mt-auto">
              <AddToCartButton productId={product.id} className="w-full" buttonClassName="bg-primary text-primary-foreground w-full" text="Add to Cart" showQuantity={false} />
            </CardFooter>
          </Card>)}
      </div>
    </div>;
}
export default function WhatContractorsOrder() {
  return <section id="what-contractors-order" className="bg-secondary py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 font-default">
            What Does Evermark Make for Electrical Contractors?
          </h2>
          <p className="text-lg text-card-foreground">
            The products electrical contractors order most from Evermark Industrial Solutions:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {contractorProducts.map((product, i) => <Card key={i} data-index={i} className="bg-card border-border overflow-hidden flex flex-col h-full">
              <AspectRatio ratio={16 / 9}>
                <img src={product.image} data-wvc-srcset={`${product.image}-wvc-srcset`} data-wvc-sizes={`${product.image}-wvc-sizes`} alt={product.title} className="object-cover w-full h-full" loading="lazy" />
              </AspectRatio>
              <CardHeader className="p-6 pb-4">
                <CardTitle className="text-xl text-white font-default">{product.title}</CardTitle>
                <CardDescription className="text-card-foreground text-base mt-2">
                  {product.description}
                </CardDescription>
              </CardHeader>
              
            </Card>)}
        </div>

        <EcommerceProductsProvider wp_query={{
        per_page: 3,
        order: "desc",
        orderby: "date"
      }}>
          <DynamicProducts />
        </EcommerceProductsProvider>
      </div>
    </section>;
}